module.exports = {
  API_CHUCHOTEURS: 'http://localhost:7001',
  API_IMAGES: 'https://api.agitateurs.com/images',
  API_CORS: 'https://api.agitateurs.com/cors',
  API_UPLOAD: 'https://api.agitateurs.com/upload',
  PORT: 7002,
};
